import posed from "react-pose"

export default posed.div({
  visible: { opacity: 1, y: 0 },
  hidden: { opacity: 0, y: 20 }
})
